module.exports = __webpack_public_path__ + "img/networkBenefits.066f9dd9.png";